var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 0.666672C4.39175 0.666672 0.666748 4.39167 0.666748 9.00001C0.666748 13.6083 4.39175 17.3333 9.00008 17.3333C13.6084 17.3333 17.3334 13.6083 17.3334 9.00001C17.3334 4.39167 13.6084 0.666672 9.00008 0.666672ZM13.1667 11.9917L11.9917 13.1667L9.00008 10.175L6.00841 13.1667L4.83342 11.9917L7.82508 9.00001L4.83342 6.00834L6.00841 4.83334L9.00008 7.82501L11.9917 4.83334L13.1667 6.00834L10.1751 9.00001L13.1667 11.9917Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 0.666672C4.39175 0.666672 0.666748 4.39167 0.666748 9.00001C0.666748 13.6083 4.39175 17.3333 9.00008 17.3333C13.6084 17.3333 17.3334 13.6083 17.3334 9.00001C17.3334 4.39167 13.6084 0.666672 9.00008 0.666672ZM13.1667 11.9917L11.9917 13.1667L9.00008 10.175L6.00841 13.1667L4.83342 11.9917L7.82508 9.00001L4.83342 6.00834L6.00841 4.83334L9.00008 7.82501L11.9917 4.83334L13.1667 6.00834L10.1751 9.00001L13.1667 11.9917Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterRemoveIcon);
export default __webpack_public_path__ + "static/media/footerRemoveIcon.7ad8f34a205c3543c42d2a556fd5c73b.svg";
export { ForwardRef as ReactComponent };